import ApprovalModificationApplication from './ApprovalModificationApplication'

export default ApprovalModificationApplication